import { createSlice } from '@reduxjs/toolkit'
import securityReducer from './reducers/securityReducer'

export type Language = {
    id: number
    country_code: string
    locale: string
    name: string
    direction: 'ltr' | 'rtl'
    default: 0 | 1
}

export interface Languages {
    countries: object
    data: object
    default: Language
}

export type Currency = {
    code: string
    default: 0 | 1
    name: string
}

export interface Currencies {
    available: Currency[]
    default: Currency
}

export interface Processes {
    [notifications: string]: {
        totalCount: number
        unreadCount: number
    }
}

export type ClientModule = {
    id: number
    code: string
    name: string
    active: 0 | 1
}

export interface InitData {
    processes: Processes
    currencies: Currencies
    languages: Languages
    available_modules: ClientModule[]
}

export interface SecurityState {
    user: object | null
    initData: InitData
}

export const initialState: SecurityState = {
    user: {},
    initData: {
        processes: {
            notifications: {
                totalCount: 0,
                unreadCount: 0,
            },
        },
        currencies: {
            available: [{ code: 'GBP', name: 'Pound sterling', default: 1 }],
            default: { code: 'GBP', name: 'Pound sterling', default: 1 },
        },
        languages: {
            default: {
                id: 1,
                country_code: 'GB',
                locale: 'en',
                name: 'LANG_1_NAME',
                direction: 'ltr',
                default: 1,
            },
            countries: {
                GB: 'LANG_1_NAME',
            },
            data: {
                en: {
                    country_code: 'GB',
                    locale: 'en',
                    name: 'LANG_1_NAME',
                    direction: 'ltr',
                    default: 1,
                },
            },
        },
        available_modules: [],
    },
}

const securitySlice = createSlice({
    name: 'security',
    initialState,
    reducers: securityReducer,
})

export const {
    setNotificationsCounts,
    setInitData,
    setLoggedInUser,
    setLanguages,
    setAvailableModules,
} = securitySlice.actions
export default securitySlice.reducer
